import * as React from 'react';
import { UIHeading2, UIText1 } from '@cian/ui-kit';

import * as styles from './styles.css';

export interface INewYearLayout {
  title?: React.ReactChild;
  content?: React.ReactChild;
  action?: React.ReactChild;
}

export const NewYearAlertLayout: React.FC<INewYearLayout> = props => {
  const { title, content, action } = props;

  return (
    <div className={styles['container']} data-testid="new-year-layout">
      {title && (
        <div className={styles['title-area']}>
          <UIHeading2>{title}</UIHeading2>
        </div>
      )}
      {content && (
        <div className={styles['content-area']}>
          <UIText1>{content}</UIText1>
        </div>
      )}
      {action && <div className={styles['action-area']}>{action}</div>}
    </div>
  );
};
